import { useState } from 'react';

const TWEMOJI_CDN = 'https://cdn.jsdelivr.net/gh/jdecked/twemoji@latest/assets/svg/';

function codepointToChar(codepoint: string): string {
  return codepoint
    .split('-')
    .map((part) => String.fromCodePoint(Number.parseInt(part, 16)))
    .join('');
}

// Renders an icon from its stored twemoji codepoint.
//
// DESIGN-DECISIONS §6 rules out relying on platform emoji: the same codepoint
// renders differently on Apple, Android, Windows and Samsung, sometimes with
// different emotional weight, and if the product IS the icon then the OS cannot
// be allowed to reinterpret it. Twemoji SVGs give one shape everywhere.
//
// v0 uses twemoji as a stand-in for the custom SVG set that decision calls for.
// The platform glyph is kept as a fallback for a blocked or unreachable CDN,
// because a reviewer with no icons at all has no product.
export function TwemojiGlyphImage(input: { codepoint: string; label: string; size?: number }) {
  const [failed, setFailed] = useState(false);
  const size = input.size ?? 26;

  if (failed) {
    return (
      <span className="glyphFallback" style={{ fontSize: size * 0.9, lineHeight: 1 }} role="img" aria-label={input.label}>
        {codepointToChar(input.codepoint)}
      </span>
    );
  }

  return (
    <img
      className="glyphImage"
      src={`${TWEMOJI_CDN}${input.codepoint}.svg`}
      alt={input.label}
      width={size}
      height={size}
      draggable={false}
      onError={() => setFailed(true)}
    />
  );
}
